/**
 * 权限判断工具（统一新旧权限）
 */

const LEGACY_PERMISSION_MAP = {
  system: [
    "dashboard.menu",
    "miniapp.menu",
    "hr.menu",
    "system.role.view",
    "system.role.manage",
    "system.permission.manage",
    "system.log.view",
  ],
  business: [
    "crm.menu",
    "order.menu",
    "crm.overview.view",
    "crm.customer.my",
    "order.contract.list",
    "order.vip.list",
    "order.service.list",
  ],
  legal: [
    "document.menu",
    "express.menu",
    "document.contract.list",
    "document.contract.audit",
    "document.lawyer.list",
    "archive.record.file",
  ],
  finance: [
    "finance.menu",
    "finance.payment.view",
    "finance.payment.edit",
    "finance.payment.manage",
    "finance.payment.export",
  ],
  communication: [
    "communication.menu",
    "communication.chat.view",
    "communication.chat.manage",
    "communication.group.list",
  ],
  user: [
    "user.menu",
    "user.view",
    "user.list",
    "user.detail",
    "user.import",
    "user.export",
  ],
  debt: [
    "debt.menu",
    "debt.view",
    "debt.list",
    "debt.detail",
    "debt.manage",
    "debt.import",
    "debt.assign",
  ],
  emp_list: ["hr.employee.list"],
  emp_add: ["hr.employee.create"],
  emp_edit: ["hr.employee.edit"],
  emp_del: ["hr.employee.delete"],
  pos_manage: ["system.role.view", "system.role.manage"],
  perm_manage: ["system.permission.manage"],
  recruit_manage: ["hr.recruitment.list"],
  salary_manage: ["hr.salary.list", "hr.salary.detail"],
  commission_manage: ["hr.commission.list", "hr.commission.detail"],
  attend_manage: ["hr.attendance.list"],
  kpi_manage: ["hr.performance.list", "hr.performance.kpi"],
  notify_list: ["notify.system.list"],
  notify_create: ["notify.system.create"],
  todo_list: ["todo.task.list"],
  todo_create: ["todo.task.create"],
  express_list: ["express.document.list"],
  express_create: ["express.document.create"],
  express_del: ["express.document.delete"],
  dashboard: ["dashboard.menu", "dashboard.home.view"],
  miniapp: [
    "miniapp.menu",
    "miniapp.config.view",
    "miniapp.banner.list",
    "miniapp.nav.list",
    "miniapp.notice.list",
    "miniapp.case.list",
  ],
  office: [
    "office.menu",
    "transfer.case.list",
    "todo.task.list",
    "notify.system.list",
  ],
  employee_portal: ["employee.menu"],
  "pay:list": ["finance.payment.view"],
  "pay:view": ["finance.payment.view"],
  "pay:edit": ["finance.payment.edit"],
  "pay:export": ["finance.payment.export"],
};

function parseUserInfo() {
  try {
    const userInfoStr = sessionStorage.getItem("userInfo");
    return userInfoStr ? JSON.parse(userInfoStr) : null;
  } catch (error) {
    console.error("解析用户信息失败:", error);
    return null;
  }
}

function ensureArray(input) {
  if (Array.isArray(input)) return input;
  if (!input) return [];
  if (typeof input === "string") return [input];
  if (typeof input === "object") return Object.values(input);
  return [];
}

export function normalizePermissionCodes(list = []) {
  const source = ensureArray(list);
  const result = [];
  const pushCode = (code) => {
    if (!code && code !== 0) return;
    const value = String(code).trim();
    if (!value || result.includes(value)) return;
    result.push(value);
  };

  source.forEach((item) => {
    const code = String(item || "").trim();
    if (!code) return;
    pushCode(code);
    if (LEGACY_PERMISSION_MAP[code]) {
      LEGACY_PERMISSION_MAP[code].forEach(pushCode);
    }
  });

  return result;
}

export function isAdminPermission(list) {
  const userInfo = list ? null : parseUserInfo();
  const permissions = normalizePermissionCodes(list || getMyPermissions());
  return !!(
    (userInfo && Number(userInfo.id) === 1) ||
    permissions.includes("*") ||
    permissions.includes("system.admin") ||
    (userInfo && userInfo.quanxian === "all")
  );
}

export function getMyPermissions() {
  const userInfo = parseUserInfo();
  if (!userInfo) return [];
  if (Number(userInfo.id) === 1 || userInfo.quanxian === "all")
    return ["*", "system.admin"];
  const rawPermissions = []
    .concat(ensureArray(userInfo.permission_codes))
    .concat(ensureArray(userInfo.quanxian));
  return normalizePermissionCodes(rawPermissions);
}

export function hasPermission(code, list) {
  if (!code) return false;
  const permissions = normalizePermissionCodes(list || getMyPermissions());
  if (isAdminPermission(permissions)) return true;
  return permissions.includes(code);
}

export function hasAnyPermission(codes, list) {
  const targetCodes = ensureArray(codes);
  if (!targetCodes.length) return false;
  return targetCodes.some((code) => hasPermission(code, list));
}

export function hasAllPermissions(codes, list) {
  const targetCodes = ensureArray(codes);
  if (!targetCodes.length) return false;
  return targetCodes.every((code) => hasPermission(code, list));
}

export default {
  normalizePermissionCodes,
  isAdminPermission,
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  getMyPermissions,
};
